import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7357dae4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "MessageFile" }
const _hoisted_2 = {
  key: 0,
  class: "MessageFile__voice"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "MessageFile__tag" }, "Голосовое сообщение", -1))
const _hoisted_4 = {
  key: 1,
  class: "MessageFile__img"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "MessageFile__tag" }, "Изображение", -1))
const _hoisted_8 = {
  key: 2,
  class: "MessageFile__file"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "MessageFile__tag" }, "Документ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ok_audio_record_mini = _resolveComponent("ok-audio-record-mini")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isVoiceMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ok_audio_record_mini, {
            url: _ctx.file.link
          }, null, 8, ["url"]),
          _hoisted_3
        ]))
      : (_ctx.isImg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "img__link",
              href: _ctx.file.link,
              target: "_blank",
              rel: "noreferrer noopener nofollow"
            }, [
              _createElementVNode("img", {
                class: "link__picture",
                alt: _ctx.file.name,
                src: _ctx.file.link
              }, null, 8, _hoisted_6)
            ], 8, _hoisted_5),
            _hoisted_7
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", {
              class: "file__link",
              href: _ctx.file.link,
              target: "_blank",
              rel: "noreferrer noopener nofollow"
            }, _toDisplayString(_ctx.file.name), 9, _hoisted_9),
            _hoisted_10
          ]))
  ]))
}